<template>
    <b-form-group>
        <b-form-radio-group @input="onSelection">
            <b-form-radio :value="yesValue">{{ yesLabel }}</b-form-radio>
            <b-form-radio :value="noValue">{{ noLabel }}</b-form-radio>
        </b-form-radio-group>
    </b-form-group>
</template>
<script>
export default {
    props: {
        yesValue: {
            type: String,
            default: '1',
        },
        noValue: {
            type: String,
            default: '0',
        },
        yesLabel: {
            type: String,
            default: 'Si',
        },
        noLabel: {
            type: String,
            default: 'No',
        },
    },
    data: () => ({
        result: '',
    }),
    computed: {
        //
    },
    methods: {
        onSelection(val) {
            this.result = val
            this.$emit('input', val)
        },
    },
}
</script>
